<template>
	<Layout :class="'bg-white p-2'">
		<Row class="m-1">
			<Col class="p-1" span="3">
			<Select v-model="searchKey.deviceType" clearable placeholder="设备型号" class="w-100">
				<Option v-for="item in deviceType" :value="item.deviceTypeNum">{{ item.deviceType }}</Option>
			</Select>
			</Col>
			<Col class="p-1" span="2">
			<Input v-model="searchKey.controlDataNum" placeholder="编号" />
			</Col>
			<Col class="p-1" span="14">
			<Input v-model="searchKey.controlData" placeholder="请输入检索内容" />
			</Col>
			<Col class="p-1" span="3">
			<Select v-model="searchKey.lie" class="w-100">
				<Option v-for="item in state" :value="item.value">{{ item.label }}</Option>
			</Select>
			</Col>
			<Col class="p-1" span="2">
			<Button class="m-1 float-right" type="primary" shape="circle" @click="search">查询</Button>
			</Col>
		</Row>
		<Row class="m-1">
			<Col class="p-1" span="3">
			<Input disabled v-model="updKey.controlDataId" placeholder="编号" />
			</Col>
			<Col class="p-1" span="19">
			<Input v-model="updKey.controlData" placeholder="数据内容" />
			</Col>
			<Col class="p-1" span="2">
			<Button class="m-1 float-right" v-show="updIf" type="primary" @click="updateControlData">保存</Button>
			</Col>
		</Row>
		<Row class="m-1">
			<Col class="p-1" span="3">
			<Select v-model="newControlData.deviceType" placeholder="设备型号" class="w-100">
				<Option v-for="item in deviceType" :value="item.deviceTypeNum">{{ item.deviceType }}</Option>
			</Select>
			</Col>
			<Col class="p-1" span="2">
			<Input v-model="newControlData.controlDataNum" placeholder="编号" />
			</Col>

			<Col class="p-1" span="17">
			<Input v-model="newControlData.controlData" clearable placeholder="请输入新增内容" />
			</Col>
			<Col class="p-1" span="2">
			<Button class="float-right m-1" type="error" @click="addControlData">新增</Button>
			</Col>
		</Row>
		<Layout :class="'bg-white'">
			<Table border :class="'m-1'" :columns="tableInfo.columnInfo" :data="tableInfo.data">
				<template slot-scope="{ row, index }" slot="deviceType">
					{{turnDeviceNumToDevice(row)}}
				</template>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" v-show="!updIf" style="margin-right: 5px"
						@click="show(row)">编辑</Button>
					<Button type="error" size="small" v-show="!row.lie && !updIf" @click="remove(row)">删除</Button>
					<Button type="error" size="small" v-show="row.lie" @click="remove(row)">恢复</Button>
				</template>
			</Table>
			<Page :class="'m-2 text-right'" :page-size="tableInfo.pageSize" @on-change="pageSearch"
				:total="tableInfo.total" />
		</Layout>
	</Layout>
</template>
<script>
	import {
		forEach
	} from 'core-js/es7/array';
	export default {
		data() {
			return {
				updIf: null,
				updKey: {
					controlDataId: "",
					controlData: "",
				},
				searchKey: {
					controlDataId: "",
					controlData: "",
					lie: "",
					controlDataNum: "",
					deviceType: "",
				},
				newControlData: {
					deviceType: "",
					controlDataNum: "",
					controlData: "",
				},
				tableInfo: {
					currentPage: 1,
					total: 0,
					pageSize: 10, //每页显示10条

					columnInfo: [{
							title: "控制数据编号",
							align: 'center',
							key: "controlDataNum",
							width: 100
						},
						{
							title: "设备型号",
							align: 'center',
							slot: 'deviceType',
							width: 150
						},
						{
							title: "控制数据",
							align: 'center',
							key: "controlData",
						},
						{
							title: "操作",
							align: 'center',
							slot: 'action',
							width: 150
						}
					],
					data: []
				},
				state: [{
						value: '',
						label: '全部'
					},
					{
						value: 'true',
						label: '已删除'
					},
					{
						value: 'false',
						label: '未删除'
					}
				],
				deviceType: []

			}
		},
		methods: {
			init: function() {
				if (!JSON.parse(sessionStorage.getItem("CURRENT_USER")).adm) {
					this.$tabs.close();
					this.deviceList(JSON.parse(sessionStorage.getItem("CURRENT_USER")).userId)
				}
				this.$data.tableInfo.currentPage = 0;
				this.search();
				this.searchDeviceType();
			},
			addControlData: function() {
				if (this.$data.newControlData.controlData.length === 0) {
					this.message.error("数据内容必须输入");
					return;
				}
				this.http.post({
					url: "/control-data/new",
					param: this.$data.newControlData
				}).then(data => {
					this.search()
					this.$Message.success('新增成功');
				});
			},
			show: function(row) {
				this.updIf = true;
				this.updKey.controlDataId = row.controlDataId;
				this.updKey.controlData = row.controlData;
			},
			turnDeviceNumToDevice: function(row) {
				var deviceType = "...";
				if (row.deviceType != null) {
					this.$data.deviceType.forEach(item => {
						if (item.deviceTypeNum == row.deviceType) {
							deviceType = item.deviceType;
						}
					})
				}
				return deviceType
			},
			updateControlData() {
				this.http.put({
					url: "/control-data/update",
					param: this.updKey
				}).then(data => {
					this.$Message.success('修改成功');
					this.updKey.controlData = "";
					this.updKey.controlDataId = "";
					this.search();
					this.updIf = !this.updIf;
				});
			},
			remove: function(row) {
				if (row.lie == true) {
					this.message.confirm({
						title: "恢复提示",
						content: "即将恢复控制数据，确定吗？",
						onOk: () => {
							row.lie = !row.lie;
							this.http.put({
								url: "/control-data/update",
								param: row

							}).then(data => {

								this.search();
							});
						},
						onCancel: () => {
							this.message.info('操作已取消');
						}
					});
				} else {
					this.message.confirm({
						title: "删除提示",
						content: "即将删除控制数据，确定吗？",
						onOk: () => {
							row.lie = !row.lie;
							this.http.put({
								url: "/control-data/update",
								param: row
							}).then(data => {

								this.search();
							});
						},
						onCancel: () => {
							this.message.info('操作已取消');
						}
					});
				}
			},
			search: function() {
				this.http.get({
					url: "/control-data/page",
					param: this.searchKey
				}).then(data => {
					this.$data.tableInfo.currentPage = data.current;
					this.$data.tableInfo.total = data.total;
					this.$data.tableInfo.pageSize = data.size;
					this.$data.tableInfo.data = data.records;
				});
			},
			searchDeviceType: function() {
				this.http.get({
					url: "/device-type/list",
				}).then(data => {
					this.$data.deviceType = data;
				});
			},
			deviceList(userId) {
				this.$router.push({
					name: "device",
					params: {
						userId
					}
				})
			},

			pageSearch: function(changedPage) {
				this.$data.tableInfo.currentPage = changedPage;
				this.searchKey.current = changedPage;
				this.search();
			}
		},
		created: function() {
			this.init();
		}

	}
</script>

<style>

</style>
